// Components==============
import React, { createContext, useMemo, useState } from 'react';
import { HeroContent } from 'typings';
// =========================

type GlobalHeroContentContextType = {
  heroContent: HeroContent;
  setHeroContent: React.Dispatch<React.SetStateAction<HeroContent>>;
};

export const GlobalHeroContentContext = createContext(
  {} as GlobalHeroContentContextType
);

export default function GlobalHeroContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const [heroContent, setHeroContent] = useState<HeroContent>(undefined);

  const value = useMemo(
    () => ({
      heroContent,
      setHeroContent,
    }),
    [heroContent]
  );

  return (
    <GlobalHeroContentContext.Provider value={value}>
      {children}
    </GlobalHeroContentContext.Provider>
  );
}
